// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"3814":"d10158d5f41b1089","4033":"8326a11bb0f1a5b9","6350":"cc24ee7447e81951","7856":"51873d0e2106c2f8"}[chunkId] + ".js";
};